import React from "react";

export interface IconProps {
  width?: number;
  height?: number;
  color?: string;
}

export default function CheckIcon(props: IconProps): JSX.Element {
  const { width, height, color } = props;
  return (
    <svg
      width={width || 10.5}
      height={height || 7.889}
      viewBox="0 0 10.5 7.889"
    >
      <path
        data-name="Path 979"
        d="M3.342 6.209l-2.084-2.03a.6.6 0 00-.834 0 .56.56 0 000 .812l2.5 2.43a.6.6 0 00.84 0l6.315-6.142a.56.56 0 000-.812.6.6 0 00-.834 0z"
        fill={color || "#fff"}
        stroke={color || "#fff"}
        strokeWidth={0.5}
      />
    </svg>
  );
}
